// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-InformationBox__wrapper","iconWrapper":"c-InformationBox__iconWrapper","headerWrapper":"c-InformationBox__headerWrapper","header":"c-InformationBox__header","headerText":"c-InformationBox__headerText","text":"c-InformationBox__text","buttonsWrapper":"c-InformationBox__buttonsWrapper","buttons":"c-InformationBox__buttons"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/InformationBox/InformationBox.scss
// module id = 575
// module chunks = 0